import { get, post } from 'aws-amplify/api';
import { getAuthHeaders } from 'utils/commonUtils';

export const getTutoringSubjects = async () => {
  const { body } = await get({
    apiName: 'deltaSnp-api',
    path: '/tutoringSubjects',
    options: { headers: await getAuthHeaders() },
  }).response;
  return body.json();
};

export const getTutoringAvailability = async (subjectId, checkDate) => {
  const { body } = await get({
    apiName: 'deltaSnp-api',
    path: '/tutoringAvailability',
    options: {
      headers: await getAuthHeaders(),
      queryParams: { subjectId: String(subjectId), checkDate: String(checkDate) },
    },
  }).response;
  return body.json();
};

export const postTutoringAvailability = async (payload) => {
  await post({
    apiName: 'deltaSnp-api',
    path: '/tutoringAvailability',
    options: {
      headers: await getAuthHeaders(),
      body: payload,
    },
  }).response;
};
